/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { openModalWithBody, closeModal } from '../../utils/modal-helpers';
//= require selectize.min
//= require_self
//= require ./pdf_viewer/pdf_viewer
//= require ./markdown_editor

window.classnames = require('classnames');

window.DocumentIssues = {
  verifiers: ['verifier', 'verifier_supervisor'],

  _spinnerTemplate: "<div style='background-color: grey; opacity: 0.2; padding: 50px;'><div class='spinner dark' style='background: white;'></div></div>",

  _pinIssueStateInitials(state) {
    if (state) { return state[0].toUpperCase(); } else { return ''; }
  },

  _onEditIssueClick(phase_id, e) {
    e.preventDefault();
    return this._showEditModal(e, phase_id, 'edit');
  },

  _onDuplicateIssueClick(phase_id, e) {
    e.preventDefault();
    return this._showEditModal(e, phase_id, 'duplicate');
  },

  _onIssueCommentCreate(e, issue) {
    const $commentsCount = $(`#${issue.id} .comments-count`);
    return $commentsCount.text(parseInt($commentsCount.text()) + 1);
  },

  _onIssueSave(e, response) {
    $(document).trigger('create_issue', response);
    closeModal('new-issue');
    this._updateIssuesJSON(response);
    this._refreshIssuesBreakdown();
    return $(document).trigger('addIssueToViewer', [response]);
  },

  _onLinkIssueSave(e, response) {
    closeModal('link-issue');
    return $(document).trigger('editIssueInViewer', [response]);
  },

  _scrollToRefresh() {
    const element = document.getElementById('pagesContainer_documentViewer');
    return $(element).scroll();
  },

  _refreshIssuesBreakdown() {
    const breakdownHtml = _.map(_.groupBy(this.issues, 'state'), (issues, state) => `<div class='data-count'>${issues.length} ${I18n.t(state, { scope: 'v4.issues.state' })}</div>`);
    $('#issues-breakdown .data-value').html(breakdownHtml.join("\n"));
    return $('.issues-count').text(`(${this.issues.length})`);
  },

  _updateIssuesJSON(updatedIssue) {
    const issue = _.find(this.issues, { id: updatedIssue.id });
    if (issue) {
      _.extend(issue, updatedIssue);
    } else {
      this.issues.push(updatedIssue);
    }
    return this._updateSelectizerOptions();
  },

  _updateSelectizerOptions() {
    $('#category_id').selectize()[0].selectize.addOption(this.issues);
    return $('#category_id').selectize()[0].selectize.refreshOptions();
  },

  _onIssueUpdate(e, response) {
    this._updateIssuesJSON(response);
    this._refreshIssuesBreakdown();
    closeModal('edit-issue');
    $(document).trigger('editIssueInViewer', [response]);
    return this._scrollToRefresh();
  },

  _showCreateModalForIssueType(e, values) {
    return this._showCreateModal(values);
  },

  _showLinkModal(x, y, pageNumber) {
    const urlParams = $.param({ 'document_id': this.documentId });
    return openModalWithBody(
      'link-issue',
      '#link-issue',
      `/workplace/projects/${this.tenderId}/phases/${this.phaseId}/document_version_issues/link?${urlParams}`,
      {},
      (response) => {
        $("#link-issue input[name='document_version_issue[coordinate_x]']").val(x);
        $("#link-issue input[name='document_version_issue[coordinate_y]']").val(y);
        $("#link-issue input[name='document_version_issue[page_number]']").val(pageNumber);
        DocumentIssues.markDeleted = false;
      }
    );
  },

  _showEditModal(e, phase_id, action) {
    const $target = $(e.currentTarget);
    const id = $target.attr('data-id');
    const documentVersionId = $target.data().document_version_id;

    $('#edit-issue').foundation('reveal', 'open').html(this._spinnerTemplate);
    return this.issuesAndCategories().done(() => {
      return $.ajax({
        url: `/workplace/projects/${this.tenderId}/phases/${this.phaseId}/document_version_issues/${id}/${action}`,
        success: response => {
          $('#new-issue').html('');
          $('#edit-issue').html(response);
          return this._initializeFormValidations();
        }
      });
    });
  },

  _onLinkIssueChange(e) {
    $('#link-issue input[type=submit]').exists().prop({ disabled: e.target.value === '' });
    return $('#link-issue form').exists().prop({ method: 'PUT', action: `/workplace/projects/${this.tenderId}/phases/${this.phaseId}/document_version_issues/${e.target.value}.json` });
  },

  _onIssueError(e, data, status, xhr) {
    const {
      errors
    } = data.responseJSON;
    $('#category-error').closest('.columns').toggleClass('error', !_.isEmpty(errors.type_category_id));
    $('#title-error').closest('.columns').toggleClass('error', !_.isEmpty(errors.title));
    return $('#description-error').closest('.columns').toggleClass('error', !_.isEmpty(errors.description));
  },

  _initializeIssueFormActions() {
    $(document).on('update_issue', _.bind(this._onIssueUpdate, this));
    $(document).on('create_issue_comment', _.bind(this._onIssueCommentCreate, this));
    $('#new-issue').on('ajax:success', _.bind(this._onIssueSave, this));
    $('#new-issue').on('ajax:error', _.bind(this._onIssueError, this));
    $('#edit-issue').exists().on('ajax:success', (e, response) => $(document).trigger('update_issue', response));
    $('#edit-issue').exists().on('ajax:error', _.bind(this._onIssueError, this));
    return $('#edit-issue').foundation().on('opened.fndtn.reveal', this._refreshMarkdownEditorContent);
  },

  _initializeFormValidations() {
    return $(document).foundation({
      abide: {
        patterns: {
          title_length: /^.{2,100}$/
        }
      }
    });
  },

  _refreshMarkdownEditorContent() {
    return MarkdownEditor.refreshContent();
  },

  initializeForm(json, newRecord) {
    if (newRecord == null) { newRecord = false; }
    const issues = this._issuesJson.issue_types;
    const categories = this._issuesJson.issue_categories;

    this._initializeFormValidations();
    MarkdownEditor.initialize('#markdown-editor');

    const initialIssueTypeId = $('#document_version_issue_type_id').val();

    $('.issue-severity-option').on('click', function (e) {
      e.preventDefault();
      const element = $(this);
      $('#severity-drop a').removeClass('selected');
      element.addClass('selected');
      $('#selected-issue-severity').html(element.html());
      $('#document_version_issue_severity').val(element.data('severity'));
      return $('#severity-error').css('display', 'none');
    });

    if ($('#document_version_issue_boq_item_id').length) {
      let currentLevel = 0;
      const tmpArr = [];
      $('#document_version_issue_boq_item_id').selectize({
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'title',
        searchField: 'title',
        maxItems: 1,
        maxOptions: 999999,
        // options: json.boq_items
        options: JSON.parse(json.boq_items),

        render: {
          option(item, escape) {
            if (item.level <= currentLevel) { _.each(__range__((item.level + 1), tmpArr.length, true), n => { return tmpArr[n] = 0; }); }
            tmpArr[item.level] = (tmpArr[item.level] || 0) + 1;
            currentLevel = item.level;
            return `<div data-depth='${item.level}' data-level='${tmpArr.slice(0, +item.level + 1 || undefined).join('.')}'>${item.title}</div>`;
          }
        }
      }).selectize;
    }

    this.issuesSelect = $('#document_version_issue_title_or_type_id').selectize({
      plugins: ['remove_button'],
      valueField: 'id',
      labelField: 'title',
      searchField: 'title',
      maxItems: 1,
      create: true,
      createOnBlur: true,
      onChange(id) {
        const issue = _.findWhere(issues, { id: parseInt(id) });
        $('#document_version_issue_type_id, #document_version_issue_description').val('');
        if (issue) {
          $('#document_version_issue_type_id').val(issue.id);
          $('#document_version_issue_title').val(issue.title);
          MarkdownEditor.setEditorValue(issue.description);
        } else {
          $('#document_version_issue_title').val(id);
        }
        return $('#description-error').css('display', 'none');
      }
    })[0].selectize;

    if (newRecord) { this.issuesSelect.disable(); }

    if (_.isEmpty(this._issuesJson.issue_categories)) { $('.issue-category').hide(); }

    this.categoriesSelect = $('#document_version_issue_type_category_id').selectize({
      plugins: ['remove_button'],
      valueField: 'id',
      labelField: 'title',
      searchField: 'title',
      maxItems: 1,
      options: this._issuesJson.issue_categories,
      create: true,
      createOnBlur: true,
      score(search) {
        return function (item) {
          const regexp = new RegExp(search, 'i');
          if (item.title.match(regexp) ||
            _.any(item.children_titles, ct => ct.match(regexp)) ||
            _.any(item.parent_titles, pt => pt.match(regexp))) { return item.reverse_index; }
        };
      },
      render: {
        option(item, escape) {
          return `<div data-depth='${item.level}'>${item.title}</div>`;
        }
      },
      onChange: value => {
        this.issuesSelect.clearOptions();
        if (value) {
          this.issuesSelect.enable();
          const category = _.findWhere(categories, { id: parseInt(value) });
          if (category) {
            $('#document_version_issue_category_name').val('');
            this.issuesSelect.addOption(_.where(issues, { parent_id: parseInt(value), children_count: 0 }));
            return this.issuesSelect.refreshOptions();
          } else {
            $('#document_version_issue_type_category_id').val('');
            return $('#document_version_issue_category_name').val(value);
          }
        } else {
          return this.issuesSelect.disable();
        }
      }
    })[0].selectize;

    if ((json.edit || json.duplicate) && !_.isEmpty(this._issuesJson.issue_categories)) { return this._selectInitialValues(json); }
  },

  _selectInitialValues(json) {
    if (json.type_category_id === null) {
      this.categoriesSelect.addOption({ id: json.category_name, title: json.category_name });
      this.categoriesSelect.setValue(json.category_name);
    } else {
      this.categoriesSelect.setValue(json.type_category_id);
    }

    if (json.selected_type) {
      $('#document_version_issue_title_or_type_id')[0].selectize.setValue(json.selected_type);
    } else {
      this.issuesSelect.addOption({ id: json.title, title: json.title });
      this.issuesSelect.setValue(json.title);
    }
    return MarkdownEditor.setEditorValue(json.description);
  },

  _scrollToBoQItem(id) {
    const navBarHeight = $('#main-nav-bar').height();
    const boqItemPosition = $(`li[did=${id}]`).offset().top;

    return $('body').scrollTo(boqItemPosition - navBarHeight);
  },

  _expandBoQItem(e, id) {
    $(`li[did=${id}]`).parents('li').andSelf().find('> .item-expand a.cat-expnd:not(.cat-collapase) i.pt-plus-square').click();
    return this._scrollToBoQItem(id);
  },

  initializeSidebar(json) {
    this.tenderId = json.tender_id;
    this.phaseId = json.phase_id;
    this.documentId = json.document_id;
    this.documentVersionId = json.document_version_id;
    this.documentVersionState = json.document_version_state;
    this.userRole = json.role;
    this.isAssignedVerfier = json.assigned_verifier;
    this.unlinkedIssuesExist = json.unlinked_issues_exist;
    this.issues = json.issues;
    initializeIssuesSidebar($('#issues_sidebar').exists()[0], $('#issue-details').exists()[0], json, this.issuesAndCategories);
    $('#issues-index').on('click', '.edit-issue', _.bind(this._onEditIssueClick, this, json.phase_id));
    $('#issues-index').on('click', '.duplicate-issue', _.bind(this._onDuplicateIssueClick, this, json.phase_id));
    $(document).on('markIssueTypeAsFailed', _.bind(this._showCreateModalForIssueType, this));
    $(document).on('click', '.item.issue .page', _.bind(this._goToPage, this));
    $(document).on('update_issue', _.bind(this._onIssueUpdate, this));
    $(document).on('clickBoQItem', _.bind(this._expandBoQItem, this));
    $(document).on('showLinkModal', (event, x, y, pageNumber) => this._showLinkModal(x, y, pageNumber));
    $(document).on('isAllowedToAddIssues', () => json.can_create_issue);
    $(document).on('updateIssueCoordinates', (event, id, position) => this._updateIssueCoordinates(id, position));

    this.issuesAndCategories();
    return this._initializeIssueFormActions();
  },

  initializeIndex(json) {
    this.tenderId = json.tender_id;
    this.phaseId = json.phase_id;
    this.documentId = json.document_id;
    this.documentVersionId = json.document_version_id;
    this.documentVersionState = json.document_version_state;
    this.userRole = json.role;
    this.isAssignedVerfier = json.assigned_verifier;
    this.unlinkedIssuesExist = json.unlinked_issues_exist;
    this.issues = json.issues;
    this.currentUser = json.current_user;
    initializeIssuesIndex($('#issues-index').exists()[0], json, this.issuesAndCategories);
    $(document).on('click', '.edit-issue', _.bind(this._onEditIssueClick, this, json.phase_id));
    $(document).on('click', '.duplicate-issue', _.bind(this._onDuplicateIssueClick, this, json.phase_id));
    $(document).on('markIssueTypeAsFailed', _.bind(this._showCreateModalForIssueType, this));
    $(document).on('click', '.item.issue .page', _.bind(this._goToPage, this));
    $(document).on('update_issue', _.bind(this._onIssueUpdate, this));
    $(document).on('clickBoQItem', _.bind(this._expandBoQItem, this));
    $(document).on('isAllowedToAddIssues', () => json.can_create_issue);

    this.issuesAndCategories();
    return this._initializeIssueFormActions();
  },

  issuesAndCategories(tenderId, phaseId) {
    if (tenderId == null) {
      ({
        tenderId
      } = this);
    }
    if (phaseId == null) {
      ({
        phaseId
      } = this);
    }
    if (this._issuesJson) { return $.Deferred().resolve(this._issuesJson); }
    const promise = $.get(`/workplace/projects/${tenderId}/phases/${phaseId}/document_version_issues/categories_and_issues`);
    return promise.then(response => { return this._issuesJson = response; });
  },

  getCategoryPath(type_category_id) {
    const category = _.where(this._issuesJson.issue_categories, { id: type_category_id })[0];
    if (!category) { return; }
    const parentTitles = _.clone(category.parent_titles);
    return parentTitles.reverse().join(' > ');
  },

  bindLinkFormAction() {
    $('#link-issue').on('change', "select[name='issue_id']", _.bind(this._onLinkIssueChange, this));
    return $('#link-issue').on('ajax:success', _.bind(this._onLinkIssueSave, this));
  },

  _goToPage(e) {
    const page = $(e.currentTarget).data().value;
    return $(document).trigger('goToPage', [page]);
  },

  initializePdfViewer(pdfUrl, issues) {
    return $('#documentViewer').on('click', '#connectExisting', _.bind(this._setupLinkMarkEvent, this));
  },

  _renderMarkInnerHtml(mark) {
    return this._markInnerHtml(mark);
  },

  _updateIssueCoordinates(id, position) {
    return $.ajax({
      url: `/workplace/projects/${this.tenderId}/phases/${this.phaseId}/document_version_issues/${id}.json`,
      data: JSON.stringify({ coordinate_x: position.x, coordinate_y: position.y, page_number: position.page_number }),
      contentType: "application/json",
      dataType: 'json',
      method: 'PUT',
      success: response => {
        return $(document).trigger('update_issue', response);
      }
    });
  }
};

function __range__(left, right, inclusive) {
  let range = [];
  let ascending = left < right;
  let end = !inclusive ? right : ascending ? right + 1 : right - 1;
  for (let i = left; ascending ? i < end : i > end; ascending ? i++ : i--) {
    range.push(i);
  }
  return range;
}